<template>
  <html>
      <body class="ovrflow desk_bckgnd_img_login">      
      <Header></Header>
      <b-container class="bv-example-row cont_height mob_col_padding">
        <b-row class="justify-content-md-center dev_lr_margin row_height">
          <b-col lg="5" class="mob_col_padding dev_position">
            <div class="main_div position_fixed">
              <div class="mob-display brand-logo text-center">
                <img src="images/inspire-logo.png" alt="" class="logoImg-class" />
              </div>
              <div class="buttonStyle">
                <div class="darkbutton__controls button">
                  <b-button type="login" variant="" v-on:click="onLogin">LOGIN</b-button>
                </div>
                <div class="transparentbutton__controls button">
                  <b-button type="register" variant="" v-on:click="onRegister">REGISTER</b-button>
                </div>
                <div class="transparentbutton__controls button">
                  <b-button type="login" variant="" v-on:click="onDisclaimer">DISCLAIMER</b-button>
                </div>
                <!-- Google SSO Login -->
                <div class="darkbutton__controls button">
                  <b-button type="login" variant="" v-on:click="ssoLogin">Login with Google</b-button>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <Footer></Footer>
    </body>
  </html>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  methods: {
    onLogin() {
      this.$router.push({ path: "/login" });
    },
    onRegister() {
      this.$router.push({ path: "/groupID" });
    },
    onDisclaimer() {
      this.$router.push({ path: "/disclamier" });
    },
    ssoLogin() {
      window.location.href = "https://inspirediagnostics.app/api/sso/login-saml";
    }
  },
};
</script>
